import { css, Paragraph, styled } from 'canoe';
import React from 'react';

const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-content: center;
    justify-content: center;
    margin: ${theme.spaces.s};
  `}
`;

const Placeholder = styled.div`
  ${({ theme }) => css`
    border: 1px solid ${theme.colors.GlitterGray};
    padding: ${theme.spaces.s};
    border-radius: ${theme.borderRadius.small};
  `}
`;

export const EmptyStateText = styled(Paragraph)`
  line-height: 1.2;
  margin: 0;
  font-size: 14px;
`;

interface Props {
  title: string;
  subtitle: string | React.ReactNode;
}

export const EmptyPlaceholder = ({ title, subtitle }: Props) => (
  <Container>
    <Placeholder>
      <Paragraph size="short" align="center">
        <strong>{title}</strong>
      </Paragraph>
      {typeof subtitle === 'string' ? (
        <EmptyStateText size="short" align="center" noMargin>
          {subtitle}
        </EmptyStateText>
      ) : (
        subtitle
      )}
    </Placeholder>
  </Container>
);
